import { apiRequest } from '../../../shared/services/apiClient';

export type GlobalSearchHit = {
  id: string;
  title: string;
  subtitle?: string | null;
  href: string;
};

export type GlobalSearchGroup = {
  type: string;
  href: string;
  total: number;
  items: GlobalSearchHit[];
};

export type GlobalSearchResponse = {
  query: string;
  groups: GlobalSearchGroup[];
};

const pickGroups = (payload: any): GlobalSearchGroup[] => {
  const raw = Array.isArray(payload?.groups) ? payload.groups : Array.isArray(payload?.Groups) ? payload.Groups : [];
  return raw.map((group: any) => ({
    type: String(group?.type ?? group?.Type ?? ''),
    href: String(group?.href ?? group?.Href ?? ''),
    total: Number(group?.total ?? group?.Total ?? 0),
    items: (Array.isArray(group?.items) ? group.items : Array.isArray(group?.Items) ? group.Items : []).map((item: any) => ({
      id: String(item?.id ?? item?.Id ?? ''),
      title: String(item?.title ?? item?.Title ?? ''),
      subtitle: item?.subtitle ?? item?.Subtitle ?? null,
      href: String(item?.href ?? item?.Href ?? ''),
    })),
  })).filter((group: GlobalSearchGroup) => group.type && group.items.length > 0);
};

export const searchGlobally = async (q: string, signal?: AbortSignal): Promise<GlobalSearchResponse> => {
  const query = q.trim();
  const params = new URLSearchParams({ q: query });
  const payload = await apiRequest<any>(`/api/v1/search?${params.toString()}`, { signal });
  return {
    query: String(payload?.query ?? payload?.Query ?? query),
    groups: pickGroups(payload),
  };
};
